import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';


@Injectable()
export class BaseService {
  protected apiEndPoint = environment.apiEndPoint;
  protected pepSchemaApiBaseUrl = environment.pepSchemaApiBaseUrl;
  protected chamberId = environment.chamberId;
  constructor() { }
}